export default "__VITE_ASSET__m9LbPjJN__"